import React from 'react';

const Agreement = () => {

    return (
        <ol>\r\n<li><a href="https://tgn.medotrade.ru:23340/pdf/Env04/useragreement.pdf">Пользовательское соглашение</a></li>\r\n<li><a href="https://tgn.medotrade.ru:23340/pdf/Env04/personalagreement.pdf">Согласие на обработку персональных данных</a></li>\r\n</ol>
    )
}

export default Agreement;
